var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAlarmOffBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3883_103182)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4437 7.14291C16.7247 6.60371 15.8864 6.24286 15.0008 6.08719V5.5C15.0008 4.94772 14.5531 4.5 14.0008 4.5C13.4485 4.5 13.0008 4.94772 13.0008 5.5V6.08718C11.8763 6.28485 10.828 6.81332 10.0035 7.61771C8.9374 8.65779 8.33214 10.0756 8.33214 11.5613V16.2545L17.4437 7.14291ZM18.8054 8.60965L8.41503 19H8.43945L5.71978 21.7197L5.18945 22.25L6.25011 23.3107L6.78044 22.7803L10.5608 19H21.0566C21.3019 19 21.5008 18.7921 21.5008 18.5356C21.5008 18.2791 21.3019 18.0711 21.0566 18.0711C20.6766 18.0711 20.4095 17.936 20.1021 17.6362C19.821 17.362 19.6694 16.9972 19.6694 16.6242V11.5613C19.6694 11.06 19.6005 10.5664 19.4683 10.0925L22.7804 6.78033L23.3108 6.25L22.2501 5.18934L21.7198 5.71967L18.8149 8.62458C18.8117 8.6196 18.8086 8.61462 18.8054 8.60965ZM11.7501 21.5C11.7501 21.0858 12.0859 20.75 12.5001 20.75H15.5001C15.9143 20.75 16.2501 21.0858 16.2501 21.5C16.2501 21.9142 15.9143 22.25 15.5001 22.25H12.5001C12.0859 22.25 11.7501 21.9142 11.7501 21.5Z",
    fill: "#2F2F2F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3883_103182",
    x: 4.18945,
    y: 4.5,
    width: 20.1211,
    height: 20.8105,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3883_103182"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3883_103182",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlarmOffBlack);
export default __webpack_public_path__ + "static/media/ic-alarm-off-black.64ce55e36d8b87c66787bc98600f2dd8.svg";
export { ForwardRef as ReactComponent };